var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopySettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    width: 23,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 .1h-5.9a.75.75 0 00-.76.76v9.97c0 .42.34.75.75.75h5.92c.41 0 .75-.33.75-.75V.86A.75.75 0 0022 .1zm-1.34 9.7h-3.21a.67.67 0 110-1.36h3.2a.67.67 0 010 1.35zm0-3.28h-3.21a.67.67 0 110-1.35h3.2a.67.67 0 010 1.35zm0-3.27h-3.21a.67.67 0 110-1.35h3.2a.67.67 0 010 1.35zM6.98 11.4H1.06a.75.75 0 00-.75.75v9.98c0 .42.34.75.75.75h5.92c.42 0 .75-.33.75-.75v-9.98a.75.75 0 00-.75-.75zM5.63 21.1H2.42a.67.67 0 010-1.35h3.2a.67.67 0 010 1.35zm0-3.27H2.42a.67.67 0 010-1.35h3.2a.67.67 0 110 1.35zm0-3.27H2.42a.67.67 0 110-1.35h3.2a.67.67 0 110 1.35zM3.94 9.49A.68.68 0 004.76 9a8.04 8.04 0 015.9-5.75l-.38.37a.67.67 0 00.95.96l1.74-1.74a.67.67 0 000-.95L11.23.15a.67.67 0 00-.95.96l.7.7a9.4 9.4 0 00-7.53 6.85c-.09.36.13.73.49.83zM19.3 13.08a.67.67 0 00-.8.52 8.02 8.02 0 01-5.97 6.06l.37-.37a.67.67 0 10-.95-.96l-1.74 1.74a.67.67 0 000 .95l1.74 1.74a.67.67 0 00.95 0 .67.67 0 000-.96l-.7-.7a9.36 9.36 0 007.61-7.21.67.67 0 00-.51-.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySettingsIcon);
export default ForwardRef;